import {createSlice, Dictionary, PayloadAction} from '@reduxjs/toolkit'
import {takeEvery, getContext, call, put} from 'typed-redux-saga'
import Api from '../../api/reactpt'
import {DataState} from '../../types/dataState.type'
import _ from 'lodash'
import Equipment from 'src/models/Equipment'
import {shouldLogUserOut} from '../configureStore'

export type EquipmentState = {
  equipment: Dictionary<Equipment>
  dataState: DataState
}

const initialState: EquipmentState = {
  equipment: {},
  dataState: {state: 'unloaded'},
}

export const {actions, reducer} = createSlice({
  name: 'Equipment',
  initialState,
  reducers: {
    getEquipment: (_state: EquipmentState, _action: PayloadAction<void>) => {},
    setEquipment: (state: EquipmentState, action: PayloadAction<{equipment: Equipment[]}>) => {
      const keyed = _.keyBy(action.payload.equipment, ({id}) => id)
      const newEquipment = {...keyed} as Dictionary<Equipment>
      return {...state, equipment: newEquipment}
    },
    setDataState: (state: EquipmentState, action: PayloadAction<{dataState: DataState}>) => {
      const {dataState} = action.payload
      return {...state, dataState}
    },
    clear: (_state: EquipmentState) => {
      return {...initialState}
    },
  },
})

export const getEquipmentSaga = function* () {
  const api: Api = yield* getContext<Api>('api')
  yield* put(actions.setDataState({dataState: {state: 'loading'}}))
  try {
    const result = yield* call(api.getEquipment)
    yield* put(actions.setEquipment({equipment: result}))
    yield* put(actions.setDataState({dataState: {state: 'loaded'}}))
  } catch (error) {
    if (shouldLogUserOut(error)) {
      throw error
    } else {
      yield* put(actions.setDataState({dataState: {state: 'unloaded', error}}))
    }
  }
}

export const saga = function* () {
  yield* takeEvery(actions.getEquipment.type, getEquipmentSaga)
}
